const step = {
    PRODUCT_PREVIEW: 1,
    CUSTOMER_INFORMATION: 2,
    PAYMENT_PRODUCT: 3,
}

export {
    step,
}